import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      links={[
      ]}
      copyright="Gracious Home All Rights Reserved." // 自定义版权信息
    />
  );
};

export default Footer;
